import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { SunFill } from 'react-bootstrap-icons';

export interface QrCodeViewerHandle {
  downloadPng: () => void;
}

interface QrCodeViewerProps {
  value: string;
  height: number; // in pixels
}

const QrCodeViewer = forwardRef<QrCodeViewerHandle, QrCodeViewerProps>(({ value, height }, ref) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const downloadPng = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const pngUrl = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = pngUrl;
    link.download = 'qrcode.png';
    link.click();
  };

  useImperativeHandle(ref, () => ({ downloadPng }), []);

  return (
    <div className="qr-code-viewer text-center">
      <div className="qr-code-card-wrapper position-relative d-inline-block">
        <div
          className="qr-code-bracket qr-code-bracket-tl"
          aria-hidden
        />
        <div
          className="qr-code-bracket qr-code-bracket-br"
          aria-hidden
        />
        <div className="qr-code-card bg-white rounded-3 shadow-sm border p-3">
          <QRCodeCanvas
            value={value}
            size={height}
            level="H"
            includeMargin={true}
            ref={canvasRef}
          />
        </div>
      </div>
      <div
        className="qr-brightness-tip mt-3 rounded-3 d-flex align-items-center gap-2 px-3 py-2 text-start"
        style={{
          backgroundColor: 'rgba(255, 193, 7, 0.2)',
          border: '1px solid rgba(255, 152, 0, 0.4)',
          color: 'var(--bs-warning-emphasis, #664d03)',
        }}
      >
        <SunFill className="fs-5 flex-shrink-0" style={{ color: 'var(--bs-warning)' }} />
        <span className="small">
          Tip: When sharing with the parker, have them <b>turn screen brightness to maximum</b> before scanning for the fastest read at the gate.
        </span>
      </div>
    </div>
  );
});

QrCodeViewer.displayName = 'QrCodeViewer';

export default QrCodeViewer;
